const CIRCUIT_OPEN_ERROR_PATTERN =
  /breaker is open|circuit .* is open|circuitopenerror/i;

export class CircuitOpenError extends Error {
  readonly statusCode = 503;
  readonly circuit: string;

  constructor(circuit: string, message?: string) {
    super(message ?? `Circuit "${circuit}" is open`);
    this.name = "CircuitOpenError";
    this.circuit = circuit;
  }
}

export function isCircuitOpenError(error: unknown): error is CircuitOpenError {
  return error instanceof CircuitOpenError;
}

export function isCircuitOpenLikeError(error: unknown): boolean {
  return (
    error instanceof Error &&
    (isCircuitOpenError(error) ||
      error.name === "CircuitOpenError" ||
      CIRCUIT_OPEN_ERROR_PATTERN.test(error.message))
  );
}
